import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeCurrencySettingsCreate,
  detail: routeCurrencySettingsDetail,
  home: routeCurrencySettingsHome,
  root: routeCurrencySettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-currency',
  createPath: 'new-currency',
  detailName: 'currency-detail',
  doctype: DOCTYPES.CURRENCY,
  homeName: 'currency',
  path: 'currency',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/currency/AddCurrency.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/currency/ViewCurrency.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeCurrencySettingsCreate,
  routeCurrencySettingsDetail,
  routeCurrencySettingsHome,
  routeCurrencySettingsRoot,
}
